const getters = {
    getCycleCount: (state) => {
        let cycleCount = _.toArray(state.cyclecount);
         return cycleCount;
      },
}

export default getters